import React, { useState, useEffect, Fragment,memo ,useCallback} from 'react';
import { useSnackbar } from 'notistack';
import moment from 'moment';
import Skeleton from '@material-ui/lab/Skeleton';
import useWindowHeight from '../../../shared_elements/hooks/useWindowHeight';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import EditIcon from '@material-ui/icons/Edit';
import AddIcon from '@material-ui/icons/Add';
import { Paper, Grid, ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails, Button, Tooltip,Chip, Tabs, Tab,TextField, InputAdornment, CircularProgress, Checkbox } from '@material-ui/core';
import { ExportManu, DeletePopUp, PageLoader, Pagination } from '../../../shared_elements';
import { DocumentAnswer, SortItems, AddNewContent, EditContentItem, ImportTemplate, ImportSections,PublishFileStatus } from '../components';
import { FormSkeletonLoader, FormWrapper } from '../../Elements';
import { checkApiStatus, downloadFileType, getLocalStorageInfo, onCheckFormPermission, onCheckPermission } from '../../../utils_v2';
import { trackActivity } from '../../../utils/mixpanel';
import { globalGetService, globalPutService, globalPostService, globalDeleteService } from '../../../utils_v2/globalApiServices';
import { globalStaticExportService } from '../../../globalServices';
import { castleAirInstance } from '../../../shared_elements/components';
import ReadMoreInline from '../../../shared_elements/components/ReadMoreInline';
import InvalidUrl from '../../../shared_elements/components/InvalidUrl';
import { browserHistory } from 'react-router';
import RestrictedAccess from '../../../shared_elements/components/RestrictedAccess';
import ImportSubSectionCheck from '../components/ImportSubSection';
import QuestionList from '../components/QuestionList';
import { Check, Clear } from '@material-ui/icons';

const SectionTextField = memo(({ section, fieldKey, label, onSave }) => {
    const [value, setValue] = useState(section[fieldKey] || '');
    const [oldVal, setOldValue] = useState(section[fieldKey] || '');
    const [saving, setSaving] = useState(false);
    const [isEdit, setEdit] = useState(false);

    useEffect(() => {
        setValue(section[fieldKey] || '');
        setOldValue(section[fieldKey] || '');
    }, [section.id, section[fieldKey]]);

    const handleBlur = () => {
        if (value.trim() === section[fieldKey]) return;
        setSaving(true);
        setOldValue(value.trim())
        onSave(value.trim(), section, fieldKey).finally(() => setSaving(false));
    };
    const enters = value.split('\n').length + (value.length > 200 ? value.length/150:1)
    return (
        <TextField
            size="small"
            fullWidth
            multiline
            rows={enters}
            label={label}
            disabled={isEdit ? false : true}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            InputProps={{
                endAdornment: saving ? <CircularProgress size={18} /> : !isEdit ?
                    <Tooltip title='Edit' arrow placement='bottom'>
                        <EditIcon style={{ cursor: 'pointer', fontSize: "19px" }} color='primary' onClick={() => setEdit(true)} />
                    </Tooltip> :
                    isEdit ? <>
                        <Tooltip title='Save' arrow placement='bottom'>
                            <Check color='primary' style={{ cursor: 'pointer' }} onClick={() => { handleBlur(); setEdit(false) }} />
                        </Tooltip>
                        <Tooltip title='Cancel' arrow placement='bottom'>
                            <Clear onClick={() => { setEdit(false); setValue(oldVal) }} style={{ cursor: 'pointer' }} color='secondary' />
                        </Tooltip>
                    </> :
                        null
            }}
            InputLabelProps={{ shrink: true }}
            variant="outlined"
        />
    );
});

const Workbook = ({params}) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const windowHeight = useWindowHeight();
    const [checklistLoading, setCheckListLoading] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [tabLoading, setTabLoading] = useState(false);
    const [formLoader, setFormLoader] = useState(true);
    const [skeletonLoader, setSkeletonLoader] = useState(true);
    const [currentFormDetail, setCurrentFormDetail] = useState(null);
    const [form11Data, setForm11Data] = useState(null);
    const [documentCheckList, setDocumentCheckList] = useState([]);
    const [documentCheckPagination, setDocumentCheckPagination] = useState({page:1, per_page:10});
    const [documentCheckSort, setDocumentCheckSort] = useState([]);
    const [error, setError] = useState({});
    const [deleteItem, setDeleteItem] = useState({modal:false, itemType:'',  sectionId:null, subSectionId:null});
    const [editItem, setEditItem] = useState({modal:false, itemType:'', data:null,  sectionId:null, subSectionId:null});
    const [importSections, setImportSections] = useState({modal:false});
    const [addSubSectionModal, setAddSubSectionModal] = useState({modal:false});
    const [publishFileStatusModel, setPublishFileStatusModel] = useState(false);
    const [importSubSections, setImportSubSections] = useState({modal:false});
    const [castleTabVal, setCastleTabVal] = useState({});
    const [questionsData, setQuestionsData] = useState({});
    const [findingSummaries, setFindingSummaries] = useState({ value: "", original: "", saving: false });
    const [selectedSectionIds, setSelectedSectionIds] = useState([]);
    const [expLoader, setExpLoader] = useState(null);
    useEffect(() => {
        getDocumentCheckList({page:1, per_page:10},'skeletonLoader');
        getCurrentFormDetail('formLoader');
        trackActivity('Project Management', {
            event_type: 'Page Visited',
            page_title: 'T013 Form'
          });
    },[]);
    const getCurrentFormDetail = (loaderType) => {
        if(loaderType){setFormLoader(true)}
        globalGetService(`technical/${params.type === 'engine' ? 'engine-workorder' :'workorder'}/${params.workOrderSlug}/forms/`,{form:params.formSlug,fields:'id,name,project_number,start_date,expected_end_date,slug'})
        .then(response => {
            if(checkApiStatus(response)){
                let form11Slug= response.data.data?.list?.find(item => item?.name =='T011')
                globalGetService(`technical/workorder/${params.workOrderSlug}/forms/`,{form:form11Slug?.slug})
                .then(res => {
                    if(loaderType){setFormLoader(false)}
                    if(checkApiStatus(res)){
                        setForm11Data(res.data.data)
                    }
                })
                setCurrentFormDetail(response.data.data)
            }
            else{
                if(loaderType){setFormLoader(false)}
            }
        })
    }
    const onChangeFormStatus = (data) => {
        if(data.status === 7 ){
            setPublishFileStatusModel(true);
        }else{
            onChangeFormStatusApi(data)
        }
    }
    const onChangeFormStatusApi = (data) => {
        setLoading(true)
        globalPostService(`technical/workorder/${params.workOrderSlug}/form/${params.formSlug}/status-update/?asset_type=${params.type}`,data)
        .then(response => {
            setLoading(false)
            if(checkApiStatus(response)){
                getCurrentFormDetail('formLoader');
                enqueueSnackbar(response.data.message, {variant: 'success', anchorOrigin:{vertical: 'top',horizontal: 'right'}});
                trackActivity('Project Management', {
                    event_type: 'Form Status Updated',
                    page_title: 'T013 Form',
                    form_slug: params.formSlug ? params.formSlug : '',
                    workOrder_slug: params.workOrderSlug ? params.workOrderSlug : '',
                    status: data.status ? data.status: '',
                    request_body: data ? data : '',
                    success_msg: response.data.message
                });
            }else{
                enqueueSnackbar(response.data.message, {variant: 'success', anchorOrigin:{vertical: 'top',horizontal: 'right'}});
                trackActivity('Project Management', {
                    event_type: 'Form Status Update Failed',
                    page_title: 'T013 Form',
                    form_slug: params.formSlug ? params.formSlug : '',
                    workOrder_slug: params.workOrderSlug ? params.workOrderSlug : '',
                    status: data.status ? data.status: '',
                    request_body: data ? data : '',
                    error_source: 'Backend',
                    error_msg: response.data.message
                });
            }
        });
    }
    const getQuestionList =(subSection)=>{
        setCheckListLoading({loader:true, id:subSection?.id});
        globalGetService(`/technical/v2/workorder/${params.workOrderSlug}/workbook/sections/${params.type}/${subSection?.id}/questions/`,{asset_type:params.type})
        .then(response=>{
            setCheckListLoading({loader:false, id:subSection?.id});
            if(checkApiStatus(response)){
                setQuestionsData(prev => ({ ...prev, [subSection?.id]: response.data.data }));
            }
        })
    }
    const getDocumentCheckList = (query={documentCheckPagination}, loaderType, questionTab) => {
        if(loaderType === 'skeletonLoader'){
            setSkeletonLoader(true)
        }else if (loaderType === 'pageLoader') {
            setLoading(true)
        }
        globalGetService(`technical/v2/workorder/${params.workOrderSlug}/workbook/sections/`,{...query,asset_type:params.type})
        .then(response => {
            if(loaderType === 'pageLoader' || loaderType === 'defaultLoader' ) {
                // setCheckListLoading(true);
            }
            if(loaderType === 'skeletonLoader'){
                setSkeletonLoader(false)
            }else if(loaderType === 'pageLoader'){
                setLoading(false)
            }
//            else{
////                setLoading(false)
//            }
            if(checkApiStatus(response)){                
                if (castleAirInstance && !(questionTab=='questionTab')) {
                    getCastletabs(response.data.data?.list)
                }
                setDocumentCheckList(response.data.data?.list);
                setDocumentCheckSort(response.data.data?.sort_list);
                setDocumentCheckPagination(response.data.data?.pagination);
                // setCheckListLoading(false);
            }
        })
    }
    const exportFormReport = (extension) => {
        enqueueSnackbar('T013 Report Downloading ...', { variant: 'info',anchorOrigin:{horizontal:'right', vertical:'bottom'}})
        setExpLoader(true)
        globalStaticExportService(`technical/v2/workorder/${params.workOrderSlug}/workbook/export/?asset_type=${params.type}`, {download:extension})
        .then(response => {
            setExpLoader(false)
            downloadFileType(response, (`T013_${getLocalStorageInfo().defaultLessor.name}_${moment().format('YYYY-MM-DD')}.`), extension);
            closeSnackbar();
            trackActivity('Project Management', {
                event_type: 'File Exported',
                page_title: 'T013 Form',
                project_slug: params.project_slug ? params.project_slug : '',
                file_name: `T013_${getLocalStorageInfo().defaultLessor.name}_${moment().format('YYYY-MM-DD')}`,
                file_extension: extension,
                success_msg: 'T013 Report Downloaded'
            })
        });
    }
    const onDeleteItem = () => {
        setLoading(true);
        if(deleteItem.itemType ==='section' || deleteItem.itemType === 'bulk-sections'){
            globalDeleteService(deleteItem.itemType === 'bulk-sections' ? `technical/v2/workorder/${params.workOrderSlug}/workbook/bulk-delete/sections/?asset_type=${params.type}` : `technical/v2/workorder/${params.workOrderSlug}/workbook/sections/${deleteItem.sectionId}/?asset_type=${params.type}`, deleteItem.itemType === 'bulk-sections' ? { ids: selectedSectionIds } : '')
            .then(response => {
                if(checkApiStatus(response)){
                    getCurrentFormDetail()
                    setSelectedSectionIds([]);
                    getDocumentCheckList({page: documentCheckPagination.page, per_page: documentCheckPagination.per_page}, 'pageLoader')
                    setDeleteItem({modal:false, itemType:'', sectionId:null, subSectionId:null});
                    enqueueSnackbar(response.data.message, {variant: 'success', anchorOrigin:{vertical: 'top',horizontal: 'right'}});
                }else{
                    setLoading(false);
                    enqueueSnackbar(response?.data?.message, {variant: 'error', anchorOrigin:{vertical: 'top',horizontal: 'right'}});
                }
            })
        } else{
            globalDeleteService(`technical/v2/workorder/${params.workOrderSlug}/workbook/sections/${deleteItem.sectionId}/sub-section/${deleteItem?.subSectionId}/?asset_type=${params.type}`)
            .then(response => {
                if(checkApiStatus(response)){
                    getDocumentCheckList({page: documentCheckPagination.page, per_page: documentCheckPagination.per_page}, 'pageLoader', deleteItem?.castleTabVal==1?'questionTab':'')
                    getCurrentFormDetail()
                    setDeleteItem({modal:false, itemType:'', sectionId:null, subSectionId:null});
                    enqueueSnackbar(response.data?.message, {variant: 'success', anchorOrigin:{vertical: 'top',horizontal: 'right'}});
                }else{
                    setLoading(false);
                    enqueueSnackbar(response?.data?.message, {variant: 'error', anchorOrigin:{vertical: 'top',horizontal: 'right'}});
                }
            })
        }
    }
    const getCastletabs = (data) => {
        const tabs = {};
        // setTabLoading(true)
         (data || []).forEach(section => {
            section.sub_sections.forEach(subSection => {
                tabs[subSection.id] = 0;
                // if(!questionsData[subSection.id]){
                    //     getQuestionList(subSection);
                    // }
                });
            });
            setCastleTabVal(tabs);
            setTabLoading(false)
    }
    const castleTabChange = (subSection, value) => {
        setCastleTabVal(prev => ({ ...prev, [subSection?.id]: value }));
        if(!questionsData[subSection?.id]){
            getQuestionList(subSection);
        }
    }
    const onEditItemType = (data) => {
        getQuestionList({id:editItem?.data?.id})
        getDocumentCheckList({page: documentCheckPagination.page, per_page: documentCheckPagination.per_page},'pageLoader', editItem?.castleTabVal==1?'questionTab':'')
        // if(editItem.itemType === 'section'){
        //     setDocumentCheckList(documentCheckList.map(section => section.id !== data.id ? section : {...section, ...data}));
        // }else{
        //     setDocumentCheckList(documentCheckList.map(section => section.id !== editItem.sectionId ? section : {...section, sub_sections: section.sub_sections.map(subSection => subSection.id !== data.id ? subSection : {...subSection, ...data})}))
        // }
        setEditItem({modal:false, itemType:'', data:null,  sectionId:null, subSectionId:null});
    }
    let formViewPermission = currentFormDetail?.list?.length && currentFormDetail?.list?.find(form => form.slug == currentFormDetail?.current_form?.slug)
    let formType = window.location?.pathname?.toUpperCase()?.includes(currentFormDetail?.current_form?.name)

    const onEditSectionField = useCallback((value, data, fieldKey) => {
        const payload = { ...data, [fieldKey]: value };
        return globalPutService(`technical/v2/workorder/${params.workOrderSlug}/workbook/sections/${data?.id}/?asset_type=${params.type}`, payload)
            .then(response => {
                if (checkApiStatus(response)) {
                    setFindingSummaries(prev => ({ ...prev, [data.id]: { ...prev[data.id], saving: false, userType: false } }));
                    trackActivity('Project Management', {
                        event_type: 'Section Data Updated',
                        page_title: 'T003 Form',
                        workOrder_slug: params.workOrderSlug || '',
                        edit_type: 'document-sections',
                        id: data.id || '',
                        request_body: payload || '',
                        response: response.data.data
                    });
                    return true;
                } else {
                    enqueueSnackbar(response.data.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    trackActivity('Project Management', {
                        event_type: 'Section Data Update Failed',
                        page_title: 'T003 Form',
                        workOrder_slug: params.workOrderSlug || '',
                        edit_type: 'document-sections',
                        id: data.id || '',
                        request_body: payload || '',
                        error_msg: response.data.data,
                        error_source: 'Backend'
                    });
                    return Promise.reject(response);
                }
            })
    },[[params.workOrderSlug, params.type]]);
     useEffect(() => {
           if (!documentCheckList ||!castleAirInstance) return;
           const initial = {};
           documentCheckList.forEach(section => {
             initial[section.id] = {value: section.finding_summary || '',original: section.finding_summary || ''};
           });
         
           setFindingSummaries(initial);
         }, [documentCheckList]);

    const onToggleSectionSelect = (e, sectionId) => {
        e.stopPropagation();
        setSelectedSectionIds(prev => prev.includes(sectionId) ? prev.filter(id => id !== sectionId) : [...prev, sectionId]);
    }

    const onSelectAllSections = (e) => {
        setSelectedSectionIds(e.target.checked ? (documentCheckList || []).map(s => s.id) : []);
    }
    console.log('documentCheckList',documentCheckList);
    return(
        <Fragment>
            <section className='project-forms-section'>
                { currentFormDetail && Object.keys(currentFormDetail).length && formType && formViewPermission ?
                    <FormWrapper 
                        hideAction={currentFormDetail?.current_form.progress === 0 ? true:false}
                        formInfo={currentFormDetail} 
                        exportReportBtn={<ExportManu expLoader={expLoader} disabled={ expLoader || (documentCheckList?.length ? false: true)} exportReportFn={(file) => exportFormReport(file.extension)} title="Export Report" files={castleAirInstance? [{title:'Excel', extension: 'xls', key:''}]: [{title:'PDF', extension: 'pdf', key:''},{title:'Doc', extension: 'docx', key:''},{title:'Excel', extension: 'xls', key:''}]} />}
                        updateFormStatusFn={(data) => onChangeFormStatus(data)}
                    />:formLoader ? <FormSkeletonLoader />:null
                }
                <div className='documents-checklist'>
                    { !skeletonLoader && onCheckFormPermission(currentFormDetail) && formType && formViewPermission ?
                        <div className='checklist-head'>
                            <Grid container spacing={1}>
                                <Grid item md={6}>
                                    <ul className='list-inline flex-centered left-cta'>
                                        <li className='list-inline-item'>
                                            <Button onClick={() =>setImportSections({modal:true, slug:params?.workOrderSlug})} color='primary' variant='outlined' size='small'><AddIcon color='primary' style={{ fontSize: '1.15rem' }} />Import Section</Button>
                                        </li>
                                    </ul>
                                </Grid>
                                <Grid item md={6}>
                                    <ul className='list-inline flex-centered right-cta'>
                                        { documentCheckList && documentCheckSort?.length > 1 ?
                                            <li className='list-inline-item'>
                                                <SortItems toolTipContent='Sort Sections' itemType='section' documentCheckList={documentCheckSort} getResponseBack={()=> getDocumentCheckList({page: documentCheckPagination.page, per_page: documentCheckPagination.per_page},'pageLoader')} />
                                            </li>:null
                                        }
                                        <li className='list-inline-item'>
                                            <AddNewContent documentCheckList={documentCheckList} addType='section' getResponseBack={() => {getCurrentFormDetail();getDocumentCheckList({page: documentCheckPagination.page, per_page: documentCheckPagination.per_page}, 'pageLoader')}} />
                                        </li>
                                    </ul>
                                </Grid>
                            </Grid>
                        </div>:null
                    }
                    { skeletonLoader ?
                        <div style={{marginTop:'10px'}}>
                            <div className='checklist-head'>
                                <Grid container spacing={1}>
                                    <Grid item md={6}>
                                        <ul className='list-inline flex-centered left-cta'>
                                            <li className='list-inline-item'>
                                                <Skeleton variant="rect" animation='wave' width={150} height={30} style={{borderRadius:4}} />
                                            </li>
                                        </ul>
                                    </Grid>
                                    <Grid item md={6}>
                                        <ul className='list-inline flex-centered right-cta' style={{float:'right'}}>
                                            <li className='list-inline-item'>
                                                <Skeleton variant="rect" animation='wave' width={130} height={30} style={{borderRadius:4}} />
                                            </li>
                                        </ul>
                                    </Grid>
                                </Grid>
                            </div>
                            <Skeleton variant="rect" width={'100%'} height={(windowHeight - 184) + 'px'} style={{marginTop:'8px'}} />
                        </div>:
                        null}
                    { skeletonLoader ? null:
                        <Paper style={{height:documentCheckList?.length ? (window.innerHeight - 230)+'px': '0px', overflow:'scroll', marginBottom:'1px'}} >
                            {onCheckFormPermission(currentFormDetail) && formType && documentCheckList.length > 0  && selectedSectionIds.length?
                        <div style={{ display: 'flex', alignItems: 'center', padding:'4px 8px 4px 16px', borderBottom: '1px solid #e0e0e0' }}>
                            {selectedSectionIds.length > 0 && <>
                                <Checkbox checked={documentCheckList.length > 0 && selectedSectionIds.length === documentCheckList.length} onChange={onSelectAllSections} color='primary' size='small' />
                                <span style={{ fontSize: '13px', marginRight: '12px' }}>Select All</span>
                                <Button onClick={() => setDeleteItem({ modal: true, itemType: 'bulk-sections', sectionId: null })} color='secondary' variant='outlined' size='small' >Delete ({selectedSectionIds.length})</Button>
                            </>}
                        </div> : null
                    }
                    
                            {
                                formType? formViewPermission ?
                                (documentCheckList || []).map((section, index) =>
                                <Paper className="section-list" key={`section_paper_${index}-header`}>
                                    <ExpansionPanel key={`expansion_${index}-header`}>
                                        <ExpansionPanelSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1a-content"
                                            id={`panel${index}-header`}
                                            key={`expansion-summary${index}-header`}
                                        >
                                            <div className='section-head'>
                                                {onCheckFormPermission(currentFormDetail) ? <Checkbox style={{right:'15px'}} checked={selectedSectionIds.includes(section.id)} onChange={(e) => onToggleSectionSelect(e, section.id)} onClick={(e) => e.stopPropagation()} color='primary' size='small' /> : null}
                                                <div style={{width:'700px'}}>
                                                <h2>{section.name}</h2>
                                                     {section.notes ?
                                                        <p className='section-notes'>
                                                            <span style={{display:"inline-flex"}}>Notes: &nbsp;
                                                                <ReadMoreInline 
                                                                text={section.notes || '--'}
                                                                />
                                                            </span>
                                                        </p> : null
                                                    }
                                                </div>
                                                {onCheckFormPermission(currentFormDetail) ?
                                                    <ul style={{ float: 'right' }} className='list-inline flex-centered'>
                                                        <li className='list-inline-item'>
                                                            <Tooltip title='Edit Section' arrow>
                                                                <EditIcon onClick={(e) => { e.stopPropagation();setEditItem({ modal: true, itemType: 'section', data: { id: section.id, name: section.name, notes:section?.notes,  order: section.order, sub_section_series: section.sub_section_series }, sectionId: section.id })}} color='primary' fontSize='small' />
                                                            </Tooltip>
                                                        </li>
                                                        <li className='list-inline-item'>
                                                            <Tooltip title='Delete Section' arrow>
                                                                <DeleteOutlineIcon onClick={(e) => { e.stopPropagation(); setDeleteItem({ modal: true, itemType: 'section', sectionId: section.id }) }} color='secondary' fontSize='small' style={{cursor:'pointer'}} />
                                                            </Tooltip>
                                                        </li>
                                                        {section.sub_sections.length > 1 ?
                                                            <li className='list-inline-item'>
                                                                <SortItems toolTipContent='Sort Sub-Sections' itemType='sub-section' sectionId={section.id} documentCheckList={documentCheckList} getResponseBack={() => getDocumentCheckList({page: documentCheckPagination.page, per_page: documentCheckPagination.per_page}, 'pageLoader')} />
                                                            </li> : null
                                                        }
                                                        <li className='list-inline-item'>
                                                        <Button startIcon={<AddIcon color='primary' fontSize='small' />} onClick={(e) => {e.stopPropagation();setImportSubSections({modal:true, sectionId:section.id, castleTab:0})}} color='primary' variant='outlined' size='small'>Import Sub Section</Button>
                                                        </li>
                                                        <li className='list-inline-item'>
                                                        <Button startIcon={<AddIcon color='primary' fontSize='small' />} onClick={(e) => { e.stopPropagation(); setAddSubSectionModal({modal:true, documentCheckList:{documentCheckList},sectionId:section.id, castleTab:castleTabVal[index]})}} color='primary' variant='contained' size='small'>Add Sub Section</Button>
                                                        </li>
                                                    </ul> : null
                                                }
                                            </div>
                                        </ExpansionPanelSummary>
                                        <ExpansionPanelDetails style={{padding:castleAirInstance ?'0px 7px 4px' :  '0px 7px 16px'}}>
                                            <div className='sub-section-list' style={{width:'100%',padding:'0px 10px 10px'}}>
                                                    <Paper>
                                                        {section.sub_sections.length === 0 ? <div className='no-data'>No Sub Section Found </div> :
                                                        section.sub_sections.map((subSections, subIndex) =>
                                                            <ExpansionPanel key={`expansion_section${subIndex}`}>
                                                                <ExpansionPanelSummary
                                                                    expandIcon={<ExpandMoreIcon />}
                                                                    aria-controls="panel1a-content"
                                                                    id={`section${subIndex}`}
                                                                    key={`section${subIndex}`}
                                                                    onClick={()=> getQuestionList(subSections)}
                                                                >
                                                                    <div className='sub-section-head'>
                                                                        <h4 style={{ width:'560px' }} >{castleAirInstance?'': `${(subIndex + 1)}.`} {subSections.name}
                                                                        {subSections.notes ?
                                                                                <p className='section-notes'>
                                                                                    <span style={{ display: "inline-flex" }}>Notes: &nbsp;
                                                                                        <ReadMoreInline
                                                                                            text={subSections.notes || '--'}
                                                                                        />
                                                                                    </span>
                                                                                </p> : null
                                                                            }
                                                                        </h4>
                                                                        <ul className='list-inline'>
                                                                            <li className='list-inline-item'>
                                                                                { castleAirInstance && !subSections.checklists.filter(item => item.status === 1).length ?null:
                                                                                <Chip label={`Received: ${subSections?.checklists?.length ? subSections.checklists.filter(item => item.status === 1).length + ` (${((subSections.checklists.filter(item => item.status === 1).length /subSections.checklists.length)*100).toFixed(2)}%)` : 0}`} size="small" style={{ background: "#277831", color: "#ffffff", width: '150px'}} />
                                                                                }
                                                                                { castleAirInstance && !subSections.checklists.filter(item => item.status === 2).length ?null:
                                                                                <Chip label={`Pending: ${subSections?.checklists?.length ? subSections.checklists.filter(item => item.status === 2).length + ` (${((subSections.checklists.filter(item => item.status === 2).length /subSections.checklists.length)*100).toFixed(2)}%)` : 0}`} size="small" style={{ margin: '5px', background: '#8f5050', color: "#ffffff", width: '150px' }} />
                                                                                }
                                                                                 { castleAirInstance && !subSections.checklists.filter(item => item.status === 3).length ?null:
                                                                                <Chip label={`N/A: ${subSections?.checklists?.length ? subSections.checklists.filter(item => item.status === 3).length +` (${((subSections.checklists.filter(item => item.status === 3).length /subSections.checklists.length)*100).toFixed(2)}%)`: 0}`} style={{ background: "#ad7900", color: "#ffffff", width: '130px' }} size="small" />
                                                                                 }
                                                                                { castleAirInstance && !subSections.checklists.length ? null:
                                                                                <Chip label={`Total Checklists: ${subSections?.checklists?.length ? subSections.checklists.length : 0}`} style={{ marginLeft: '5px', background: '#3f51b5', color: "#ffffff", width: '150px' }} size="small" />
                                                                                }
                                                                            </li>
                                                                            {onCheckFormPermission(currentFormDetail) ?
                                                                                <Fragment>
                                                                                    <li className='list-inline-item' style={{ verticalAlign: 'middle' }}>
                                                                                        <Tooltip title='Edit Sub-Section'>
                                                                                            <EditIcon onClick={(e) => { e.preventDefault(); e.stopPropagation(); setEditItem({ modal: true, itemType: 'sub-section', data: { id: subSections.id, name: subSections.name, notes:subSections?.notes, order: subSections.order }, sectionId: section.id }) }} color='primary' fontSize='small' />
                                                                                        </Tooltip>
                                                                                    </li>
                                                                                    <li className='list-inline-item' style={{ verticalAlign: 'middle' }}>
                                                                                        <Tooltip title='Delete Sub-Section' arrow>
                                                                                            <DeleteOutlineIcon onClick={(e) => { e.preventDefault(); e.stopPropagation(); setDeleteItem({ modal: true, itemType: 'sub-section', sectionId: section.id, subSectionId: subSections.id }) }} color='secondary' fontSize='small' style={{cursor:'pointer'}} />
                                                                                        </Tooltip>
                                                                                    </li>
                                                                                </Fragment> : null
                                                                            }
                                                                        </ul>
                                                                    </div>
                                                                </ExpansionPanelSummary>
                                                                <ExpansionPanelDetails style={{padding:'0px'}}>
                                                                    {castleAirInstance ?
                                                                        <Paper style={{ width: '100%', padding: '10px' }}>
                                                                             <Paper>
                                                                            <Tabs
                                                                                onChange={(_, value) => castleTabChange(subSections, value)}
                                                                                indicatorColor='primary'
                                                                                textColor='primary'
                                                                                value={castleTabVal[subSections.id] || 0}
                                                                                style={{marginBottom:'10px'}}
                                                                            >
                                                                                <Tab label='Checklist' key={`checklist_${subSections.id}`} value={0} />
                                                                                <Tab label='Questions' key={`questions_${subSections.id}`} value={1} />
                                                                            </Tabs>
                                                                            </Paper>
                                                                            {checklistLoading?.loader && checklistLoading?.id ==subSections.id ? <div style={{textAlign:'center'}}>Refreshing the Data...</div> :
                                                                                castleTabVal[subSections.id] === 1 ?
                                                                                    <QuestionList
                                                                                        getDocumentCheckList={() => {
                                                                                            getDocumentCheckList({page: documentCheckPagination.page, per_page: documentCheckPagination.per_page}, 'pageLoader', 'questionTab');
                                                                                            getQuestionList(subSections);
                                                                                        }}
                                                                                        documentCheckList={documentCheckList}
                                                                                        setDocumentCheckList={setDocumentCheckList}
                                                                                        params={params}
                                                                                        sections={{...subSections, questions: questionsData[subSections.id]?.questions}}
                                                                                        currentFormDetail={currentFormDetail}
                                                                                    />
                                                                                :
                                                                                    <DocumentAnswer
                                                                                        form11Data={form11Data}
                                                                                        getCurrentFormDetail={getCurrentFormDetail}
                                                                                        subSections={{...subSections, checklists: questionsData[subSections.id]?.checklists}}
                                                                                        currentFormDetail={currentFormDetail}
                                                                                        documentCheckList={documentCheckList}
                                                                                        sectionId={section.id}
                                                                                        oneditload={() => getDocumentCheckList({page: documentCheckPagination.page, per_page: documentCheckPagination.per_page}, 'pageLoader')}
                                                                                        getResponseBack={() => { getDocumentCheckList({page: documentCheckPagination.page, per_page: documentCheckPagination.per_page}, 'defaultLoader'); getQuestionList(subSections); }}
                                                                                    />
                                                                            }
                                                                        </Paper>
                                                                    :
                                                                        checklistLoading?.loader && checklistLoading?.id ==subSections.id  ?<Paper style={{ width: '100%', padding: '10px' }}> <div style={{textAlign:'center'}}>Refreshing the Data...</div> </Paper> :
                                                                            <DocumentAnswer
                                                                                form11Data={form11Data}
                                                                                getCurrentFormDetail={getCurrentFormDetail}
                                                                                subSections={{...subSections, checklists: questionsData[subSections.id]?.checklists}}
                                                                                currentFormDetail={currentFormDetail}
                                                                                documentCheckList={documentCheckList}
                                                                                sectionId={section.id}
                                                                                oneditload={() => getDocumentCheckList({page: documentCheckPagination.page, per_page: documentCheckPagination.per_page}, 'pageLoader')}
                                                                                getResponseBack={() => { getDocumentCheckList({page: documentCheckPagination.page, per_page: documentCheckPagination.per_page}, 'defaultLoader'); getQuestionList(subSections);}}
                                                                            />
                                                                    }
                                                                </ExpansionPanelDetails>
                                                            </ExpansionPanel>
                                                        )}
                                                    </Paper>
                                                    <Grid container spacing={3} style={{ marginTop: "6px" }}>
                                                        {castleAirInstance &&
                                                            <>
                                                                <Grid item md={12}>
                                                                    <SectionTextField key={`fs_${section.id}`} section={section} fieldKey="finding_summary" label="Finding Summary" onSave={onEditSectionField} />
                                                                </Grid>
                                                                <Grid item md={12}>
                                                                    <SectionTextField key={`sn_${section.id}`} section={section} fieldKey="finding_summary_notes" label="Summary Notes" onSave={onEditSectionField} />
                                                                </Grid>
                                                            </>
                                                        }
                                                    </Grid>
                                            </div>
                                        </ExpansionPanelDetails>
                                    </ExpansionPanel>
                                </Paper>
                            ):
                            isLoading || formLoader || skeletonLoader? null:
                            <RestrictedAccess />:
                            formLoader? null:
                            <InvalidUrl getResponseBack={()=> currentFormDetail?.project?.slug ? browserHistory.push(`/technical/project/view/${currentFormDetail?.project?.slug}`) :browserHistory.push(`/technical/projects?project_status=all`)} />
                        }
                        </Paper>
                    }
                    <Paper style={{marginBottom:'1px'}}>
                     <Pagination 
                        pagination={documentCheckPagination}
                        onChangePage={(event, newPage)=>getDocumentCheckList({page:newPage+1, per_page: documentCheckPagination.per_page}, 'pageLoader')}
                        onChangeRowsPerPage={(event)=>getDocumentCheckList({page:1, per_page: event.target.value}, 'pageLoader')}  
                        />
                        </Paper>
                </div>  
                { !skeletonLoader && documentCheckList.length === 0 && onCheckFormPermission(currentFormDetail) ?
                    <ImportTemplate 
                        getResponseBack={() => {getCurrentFormDetail();getDocumentCheckList({page: documentCheckPagination.page, per_page: documentCheckPagination.per_page},'pageLoader')}}
                    />:null
                }          
                { deleteItem.modal ?
                    <DeletePopUp
                        modal={deleteItem.modal}
                        toggleModalFn={() => setDeleteItem({modal:false, itemType:'', sectionId:null, subSectionId:null})}
                        title={`Delete`}
                        content={<h4>Are you sure you want to Delete?</h4>}
                        deleteRecordFn={() => onDeleteItem()}
                    />:null
                }
                {editItem.modal ?
                    <EditContentItem
                        params={params}
                        editItem={editItem}
                        toggleModalFn={() => setEditItem({modal:false, itemType:'', data:null, sectionId:null, subSectionId:null})}
                        getResponseBack={()=>onEditItemType()}
                        documentCheckList={documentCheckList}
                        currentFormDetail={currentFormDetail}
                    />:null
                }
                { importSections.modal?
                    <ImportSections 
                        importSections={importSections}
                        toggleModalFn={() => setImportSections({modal:false})}
                        getResponseBack={() => console.log('hi')}
                    />:null
                }
                { publishFileStatusModel ?
                    <PublishFileStatus
                        recordsPermission={onCheckPermission('records','data_room','UP')}  
                        modal={publishFileStatusModel}
                        updateFormStatusFn={(data) => onChangeFormStatusApi(data)} 
                        handleClose={() => setPublishFileStatusModel(false)} 
                    />:null
                }
                { addSubSectionModal?.modal ?
                    <AddNewContent
                    addSubSectionModal={addSubSectionModal}
                    open={true}
                    documentCheckList={addSubSectionModal?.documentCheckList?.documentCheckList}
                    sectionId={addSubSectionModal?.sectionId}
                    toggleModalFn={()=>setAddSubSectionModal({})}
                    addType={'sub-section'} 
                    getResponseBack={() => getDocumentCheckList({page: documentCheckPagination.page, per_page: documentCheckPagination.per_page}, 'pageLoader', addSubSectionModal?.castleTab ==1?'questionTab':'')}

                    />: null
                }
                 { importSubSections.modal?
                    <ImportSubSectionCheck 
                    params={params}
                    importSubSections={importSubSections}
                        toggleModalFn={() => setImportSubSections({modal:false})}
                        getResponseBack={() => console.log('hi')}
                    />:null
                }
                {isLoading || tabLoading ? <PageLoader/>:null}
            </section>
            { !skeletonLoader && !formLoader?
                    currentFormDetail && Object.keys(currentFormDetail).length && currentFormDetail.current_form.status.id !== 7  ? null : !documentCheckList.length ? <div style={{textAlign:'center', height:`${window.innerHeight-120}px`}}><h4 style={{padding:'50px 0',fontSize:'18px'}}>No Data found</h4></div>:null:null
            }
        </Fragment>
        
    )
}
export default Workbook;